<template>
  <div class="tkBadges">
    <tk-badge
      v-for="{ id, name } in items"
      :key="id"
      :removable="removable"
      :max-width="maxWidthForEachBadge"
      :padding-top="paddingTopForEachBadge"
      :padding-bottom="paddingBottomForEachBadge"
      :font-weight="fontWeight"
      @remove="removable && $emit('remove', id)"
    >
      {{ name }}
    </tk-badge>
  </div>
</template>

<script>
import TkBadge from './TkBadge'

export default {
  name: 'TkBadges',
  components: { TkBadge },
  props: {
    items: {
      type: Array,  // [{ id, name }, ...]
      required: true,
    },
    removable: {
      type: Boolean,
      default: false,
    },
    maxWidthForEachBadge: {
      type: Number,
      default: 188,
    },
    paddingTopForEachBadge: {
      type: Number,
      default: undefined,
    },
    paddingBottomForEachBadge: {
      type: Number,
      default: undefined,
    },
    fontWeight: {
      type: String,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
.tkBadges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
</style>
